<template>
    <v-layout column class="mx-5">
        <v-flex>
            <v-card>
                <v-layout row text-xs-left align-center>
                    <v-flex xs12 class="mx-5 px-5 py-5">
                        <span class="display-2 font-weight-bold">
                            Sorry, but this page is still under construction
                        </span>
                        <br> <br> <br>
                        <span>
                            We are looking to work with suppliers in the freight industry. <br>
                            If you're a supplier of haulage, freight (sea and/or air), and/or maritime insurance, feel free to contact us at <a href="info@accelefreight.com">info@accelefreight.com</a> 
                            to discuss how we can develop a partnership. <br>
                            At the meantime, do look back on this space for future updates on how we plan to help suppliers better serve our customers.
                            <br><br>
                        </span>
                    </v-flex>          
                </v-layout>   
            </v-card>    
        </v-flex>       
    </v-layout>  
</template>

<script>
export default {

}
</script>

<style>

</style>
